import React from "react";
import styled from "styled-components";
import { StageElement } from "../../../types";

const RceColumn = styled.div<{ fixedRatio?: number }>`
  position: relative;
  display: flex;
  flex: 1 1 ${(props) => props.fixedRatio || "100"}%;
  flex-direction: column;
  min-width: 0;
`;

interface ColumnProps {
  column: {
    fixedRatio?: number;
    stageElements?: StageElement[];
  };
  renderStageElement: (element: StageElement, elementIndex: string) => JSX.Element | null;
}

export const ColumnComponent: React.FC<ColumnProps> = ({ column, renderStageElement }) => {
  if (!column.stageElements) {
    return null;
  }

  return (
    <RceColumn fixedRatio={column.fixedRatio} className="spf-rce-column">
      {column.stageElements.map((element, position) =>
        renderStageElement(element, element.ref || `element-${position}`),
      )}
    </RceColumn>
  );
};
